export const priorities = [
  "P1",
  "P2",
  "P3",
  "P4",
  "P5"
];

export const coders = [
  "John Smith",
  "David",
  "William",
  "Michael",
  "Sophia",
  "Emily",
    "John Smith",
  "David",
  "William",
  "Michael",
  "Sophia",
  "Emily",
];

export const files = [
  "Episode.pdf",
  "Diagnosis.pdf",
  "Audit.pdf",
    "Episode.pdf",
  "Diagnosis.pdf",
  "Audit.pdf",
];

export const diagnosis = [
  "Diagnosis A",
  "Diagnosis B",
  "Diagnosis C",
    "Diagnosis A",
  "Diagnosis B",
  "Diagnosis C",
];

export const drgs = [
  "DRG-001",
  "DRG-002",
  "DRG-003",
];

export const speciality = [
  "Cardiology",
  "Neurology",
  "Orthopaedics",
];

export const funds = [
  "Medicare",
  "Private",
  "Government",
];

export const auditStatus = [
  "Pending Review",
  "Completed",
  "Rejected",
];

export const status = [
  "Active",
  "Inactive",
];